<template>
  <section>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="productTabs" v-model="currentTab" type="default-scroll"></tabs>
        </div>
      </div>
    </section>
    <!-- report -->
    <report v-if="currentTab === 'report'" :product_id="product_id"></report>
    <!-- campaign -->
    <campaign
      v-if="currentTab === 'campaign'"
      :product_id="product_id"
    ></campaign>
    <!-- cost product -->
    <cost v-if="currentTab === 'cost'" :product_id="product_id"></cost>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";

import Report from "./Report";
import Campaign from "./Campaign";
import Cost from "./Cost";

export default {
  name: "product-detail",
  components: {
    Tabs,
    Report,
    Campaign,
    Cost,
  },
  props: ["product_id"],
  data() {
    return {
      loading: false,
      currentTab: "report",
      productTabs: [
        {
          name: "report",
          title: "Relatório",
        },
        {
          name: "campaign",
          title: "Campanhas de Marketing",
        },
        {
          name: "cost",
          title: "Custo",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
